import React from 'react';

export default function Checkbox({
    label,
    checked,
    onChange,
}: {
    label: string;
    checked: boolean;
    onChange: () => void;
}) {
    return (
        <label className="flex items-center gap-2">
            <input type="checkbox" checked={checked} onChange={onChange} />
            <span className="select-none">{label}</span>
        </label>
    );
}
